import React, { useContext, useEffect, useState } from 'react'
import { LoginContext } from '../../reactcontext/ReactContext'
import { Link, useNavigate } from 'react-router-dom'
import { Panel } from '../../components'

const Landing = () => {
  const { loginInfo } = useContext(LoginContext)
  const navigate = useNavigate()

  const reports = [
    { id:1, title: 'Report List', components: [
        'Expired Passports',
        'Expired Visas',
        'Passports due to expire',
        'Visa due to expire',
        'Agent with Profiles',
        'Balances',
        'Collection',
    ]},
  ]

  useEffect(() => {

    !loginInfo.login && navigate("/reports")
    
  }, [loginInfo])
  
  return (
    <div className='w-full h-full flex flex-col overflow-hidden'>
      <div className='px-6 py-4 shrink-0'>
        <Link to={'/dashboard'} className='text-yellow-700'>Dashboard</Link>
        {' > '}
        Reports
      </div>

      <div className="flex-1 overflow-hidden w-full px-4 pb-4">
        {reports.map(item => (
          <div key={item.id} className="w-full h-full flex flex-col">
            <div className="w-full h-10 bg-gray-300 flex items-center justify-center rounded-t-lg shadow-md shrink-0">
              <h2 className="text-md font-bold text-center">{item.title}</h2>
            </div>
            <div className="flex-1 w-full p-6 bg-gray-100 rounded-b-lg shadow-md">
              <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4">
                {item.components.map((value, key) => (
                  <Link to={`/reports/${value}`} key={key}>
                    <div className="p-4 border rounded-lg text-blue-600 shadow-sm bg-white hover:shadow-lg transition-shadow duration-200">
                      {(key + 1) + '. ' + value}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Landing